
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiAziendeDialog extends Serenity.EntityDialog<ProdottiAziendeRow, any> {
        protected getFormKey() { return ProdottiAziendeForm.formKey; }
        protected getIdProperty() { return ProdottiAziendeRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiAziendeRow.localTextPrefix; }
        protected getService() { return ProdottiAziendeService.baseUrl; }
        protected getDeletePermission() { return ProdottiAziendeRow.deletePermission; }
        protected getInsertPermission() { return ProdottiAziendeRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiAziendeRow.updatePermission; }

        protected form = new ProdottiAziendeForm(this.idPrefix);

    }
}